import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component, Fragment } from '@wordpress/element';
import interpolateComponents from 'interpolate-components';
import { SelectControl } from '@wordpress/components';
import { find, partial } from 'lodash';
import classnames from 'classnames';
import { __, _x } from '@wordpress/i18n';
/**
 * WooCommerce dependencies
 */

import { isoDateFormat, toMoment } from '@woocommerce/date';
/**
 * Internal dependencies
 */

import DatePicker from '../calendar/date-picker';
import { textContent } from './utils';
import moment from 'moment';

var dateStringFormat = __('MMM D, YYYY', 'woocommerce-admin');

var dateFormat = __('MM/DD/YYYY', 'woocommerce-admin');

var DateFilter =
/*#__PURE__*/
function (_Component) {
  _inherits(DateFilter, _Component);

  function DateFilter(_ref) {
    var _this;

    var filter = _ref.filter;

    _classCallCheck(this, DateFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateFilter).apply(this, arguments));

    var _ref2 = Array.isArray(filter.value) ? filter.value : [null, filter.value],
        _ref3 = _slicedToArray(_ref2, 2),
        isoAfter = _ref3[0],
        isoBefore = _ref3[1];

    var after = isoAfter ? toMoment(isoDateFormat, isoAfter) : null;
    var before = isoBefore ? toMoment(isoDateFormat, isoBefore) : null;
    _this.state = {
      before: before,
      beforeText: before ? before.format(dateFormat) : '',
      beforeError: null,
      after: after,
      afterText: after ? after.format(dateFormat) : '',
      afterError: null
    };
    _this.onSingleDateChange = _this.onSingleDateChange.bind(_assertThisInitialized(_this));
    _this.onRangeDateChange = _this.onRangeDateChange.bind(_assertThisInitialized(_this));
    _this.onRuleChange = _this.onRuleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateFilter, [{
    key: "getBetweenString",
    value: function getBetweenString() {
      return _x('{{after /}}{{span}} and {{/span}}{{before /}}', 'Date range inputs arranged on a single line', 'woocommerce-admin');
    }
  }, {
    key: "getScreenReaderText",
    value: function getScreenReaderText(filter, config) {
      var rule = find(config.rules, {
        value: filter.rule
      }) || {};
      var _this$state = this.state,
          before = _this$state.before,
          after = _this$state.after; // Return nothing if we're missing input(s)

      if (!before || 'between' === rule.value && !after) {
        return '';
      }

      var filterStr = before.format(dateStringFormat);

      if ('between' === rule.value) {
        filterStr = interpolateComponents({
          mixedString: this.getBetweenString(),
          components: {
            after: createElement(Fragment, null, after.format(dateStringFormat)),
            before: createElement(Fragment, null, before.format(dateStringFormat)),
            span: createElement(Fragment, null)
          }
        });
      }

      return textContent(interpolateComponents({
        mixedString: config.labels.title,
        components: {
          filter: createElement(Fragment, null, filterStr),
          rule: createElement(Fragment, null, rule.label)
        }
      }));
    }
  }, {
    key: "onSingleDateChange",
    value: function onSingleDateChange(_ref4) {
      var date = _ref4.date,
          text = _ref4.text,
          error = _ref4.error;
      var _this$props = this.props,
          filter = _this$props.filter,
          onFilterChange = _this$props.onFilterChange;
      this.setState({
        before: date,
        beforeText: text,
        beforeError: error
      });

      if (date) {
        onFilterChange(filter.key, 'value', date.format(isoDateFormat));
      }
    }
  }, {
    key: "onRangeDateChange",
    value: function onRangeDateChange(input, _ref5) {
      var _this$setState;

      var date = _ref5.date,
          text = _ref5.text,
          error = _ref5.error;
      var _this$props2 = this.props,
          filter = _this$props2.filter,
          onFilterChange = _this$props2.onFilterChange;
      this.setState((_this$setState = {}, _defineProperty(_this$setState, input, date), _defineProperty(_this$setState, input + 'Text', text), _defineProperty(_this$setState, input + 'Error', error), _this$setState));

      if (date) {
        var _this$state2 = this.state,
            before = _this$state2.before,
            after = _this$state2.after;
        var nextAfter = null;
        var nextBefore = null;

        if ('after' === input) {
          nextAfter = date.format(isoDateFormat);
          nextBefore = before ? before.format(isoDateFormat) : null;
        }

        if ('before' === input) {
          nextAfter = after ? after.format(isoDateFormat) : null;
          nextBefore = date.format(isoDateFormat);
        }

        if (nextAfter && nextBefore) {
          onFilterChange(filter.key, 'value', [nextAfter, nextBefore]);
        }
      }
    }
  }, {
    key: "isFutureDate",
    value: function isFutureDate(dateString) {
      return moment().isBefore(moment(dateString), 'day');
    }
  }, {
    key: "getFilterInputs",
    value: function getFilterInputs() {
      var filter = this.props.filter;
      var _this$state3 = this.state,
          before = _this$state3.before,
          beforeText = _this$state3.beforeText,
          beforeError = _this$state3.beforeError,
          after = _this$state3.after,
          afterText = _this$state3.afterText,
          afterError = _this$state3.afterError;

      if ('between' === filter.rule) {
        return interpolateComponents({
          mixedString: this.getBetweenString(),
          components: {
            after: createElement(DatePicker, {
              date: after,
              text: afterText,
              error: afterError,
              onUpdate: partial(this.onRangeDateChange, 'after'),
              dateFormat: dateFormat,
              isInvalidDate: this.isFutureDate
            }),
            before: createElement(DatePicker, {
              date: before,
              text: beforeText,
              error: beforeError,
              onUpdate: partial(this.onRangeDateChange, 'before'),
              dateFormat: dateFormat,
              isInvalidDate: this.isFutureDate
            }),
            span: createElement("span", {
              className: "separator"
            })
          }
        });
      }

      return createElement(DatePicker, {
        date: before,
        text: beforeText,
        error: beforeError,
        onUpdate: this.onSingleDateChange,
        dateFormat: dateFormat,
        isInvalidDate: this.isFutureDate
      });
    }
  }, {
    key: "onRuleChange",
    value: function onRuleChange(value) {
      var _this$props3 = this.props,
          onFilterChange = _this$props3.onFilterChange,
          filter = _this$props3.filter,
          updateFilter = _this$props3.updateFilter;
      var before = this.state.before;

      if ('between' === filter.rule && 'between' !== value) {
        updateFilter({
          key: filter.key,
          rule: value,
          value: before ? before.format(isoDateFormat) : undefined
        });
      } else {
        onFilterChange(filter.key, 'rule', value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          config = _this$props4.config,
          filter = _this$props4.filter,
          isEnglish = _this$props4.isEnglish;
      var rule = filter.rule;
      var labels = config.labels,
          rules = config.rules;
      var screenReaderText = this.getScreenReaderText(filter, config);
      var children = interpolateComponents({
        mixedString: labels.title,
        components: {
          title: createElement("span", {
            className: className
          }),
          rule: createElement(SelectControl, {
            className: classnames(className, 'woocommerce-filters-advanced__rule'),
            options: rules,
            value: rule,
            onChange: this.onRuleChange,
            "aria-label": labels.rule
          }),
          filter: createElement("div", {
            className: classnames(className, 'woocommerce-filters-advanced__input-range', {
              'is-between': 'between' === rule
            })
          }, this.getFilterInputs())
        }
      });
      /*eslint-disable jsx-a11y/no-noninteractive-tabindex*/

      return createElement("fieldset", {
        className: "woocommerce-filters-advanced__line-item",
        tabIndex: "0"
      }, createElement("legend", {
        className: "screen-reader-text"
      }, labels.add || ''), createElement("div", {
        className: classnames('woocommerce-filters-advanced__fieldset', {
          'is-english': isEnglish
        })
      }, children), screenReaderText && createElement("span", {
        className: "screen-reader-text"
      }, screenReaderText));
      /*eslint-enable jsx-a11y/no-noninteractive-tabindex*/
    }
  }]);

  return DateFilter;
}(Component);

export default DateFilter;
//# sourceMappingURL=date-filter.js.map